import { MediaWeb } from '@nucleus/types/web';
import { BackgroundComposition } from '@nucleus/web-theme-elements';
import React from 'react';
import styled from 'styled-components';

type BackgroundMediaProps = {
  background?: MediaWeb;
  fallbackColor?: string;
};

export const SectionBackground = ({
  background,
  fallbackColor = 'var(--color-section-background)',
}: BackgroundMediaProps): JSX.Element => {
  const fallbackColorValue =
    background?.themeColorKey !== undefined ? `var(--color-${background.themeColorKey})` : fallbackColor;
  return (
    <BackgroundComposition
      background={background}
      baseClassNames={['background', 'section-background']}
      fallbackColor={fallbackColorValue}
    />
  );
};

export const BlockBackground = ({
  background,
  fallbackColor = 'var(--color-block-background)',
}: BackgroundMediaProps): JSX.Element => {
  const fallbackColorValue =
    background?.themeColorKey !== undefined ? `var(--color-${background.themeColorKey})` : fallbackColor;
  return (
    <StyledBackgroundComposition
      background={background}
      baseClassNames={['background', 'block-background']}
      fallbackColor={fallbackColorValue}
    />
  );
};

export const MediaItemBackground = ({
  background,
  fallbackColor = 'var(--color-media-background)',
}: BackgroundMediaProps): JSX.Element => {
  const fallbackColorValue =
    background?.themeColorKey !== undefined ? `var(--color-${background.themeColorKey})` : fallbackColor;
  return (
    <BackgroundComposition
      background={background}
      baseClassNames={['media', 'media-item']}
      fallbackColor={fallbackColorValue}
    />
  );
};

export const CardBackground = ({
  background,
  fallbackColor = 'var(--color-block-background)',
}: BackgroundMediaProps): JSX.Element => {
  const fallbackColorValue =
    background?.themeColorKey !== undefined ? `var(--color-${background.themeColorKey})` : fallbackColor;
  return (
    <BackgroundComposition
      background={background}
      baseClassNames={['background', 'card-background']}
      fallbackColor={fallbackColorValue}
    />
  );
};

export const CardMediaItemBackground = ({
  background,
  fallbackColor = 'var(--color-dark)',
}: BackgroundMediaProps): JSX.Element => {
  const fallbackColorValue =
    background?.themeColorKey !== undefined ? `var(--color-${background.themeColorKey})` : fallbackColor;
  return (
    <BackgroundComposition
      background={background}
      baseClassNames={['media', 'card-media-item']}
      fallbackColor={fallbackColorValue}
    />
  );
};

const StyledBackgroundComposition = styled(BackgroundComposition)`
  z-index: -1;
`;
